import {EmailsInputItem, ValidType} from './emails-input'

export const getStatusContainer = (emails: EmailsInputItem[]): ValidType => {
  const hasErrors = emails.some(i => i.valid === 'error')

  if (hasErrors) {
    return 'error'
  }

  const hasWarnings = emails.some(i => i.valid === 'warning')
  if (hasWarnings) {
    return 'warning'
  }

  return 'success'
}

export const reorder = (emails: EmailsInputItem[]): void => {
  const hasErrors = emails.some(i => i.valid === 'error')
  const hasWarnings = emails.some(i => i.valid === 'warning')

  if (!hasErrors && !hasWarnings) {
    return
  }

  emails.sort((b, a) => {
    if (a.valid === b.valid) {
      return 0
    }

    if (a.valid === 'error') {
      return 1
    }

    if (b.valid === 'error') {
      return -1
    }

    if (a.valid === 'warning') {
      return 1
    }

    if (b.valid === 'warning') {
      return -1
    }

    return 0
  })
}
